import { useCreateRoom } from "../api/useCreateRoom"
import { useDeleteRoom } from "../api/useDeleteRoom"
import { useUpdateRoom } from "../api/useUpdateRoom"

export function useRoomMutations() {
  const [createRoom] = useCreateRoom()
  const [updateRoom] = useUpdateRoom()
  const [deleteRoom] = useDeleteRoom()

  return {
    createRoom,
    updateRoom,
    deleteRoom
  }
}
